/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_LabelInputs */

const vi_order_channel_label = /** @type {(inputs: Order_Channel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kênh bán`)
};

/**

* @param {Order_Channel_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_label = /** @type {((inputs?: Order_Channel_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_label(inputs)
});